import * as types from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

export const initialState = false;

const open = () => true;

const close = () => false;

export default createReducer(initialState, {
  [LOCATION_CHANGE]: close,
  [types.CLOSE_MOBILITY_MODAL]: close,
  [types.OPEN_MOBILITY_MODAL_READY]: open,
});
